import React from 'react';

import { createStyles, withStyles, Theme, Grid } from '@material-ui/core';

import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import Filters from '../../common/AnalyticsFilters';
import AnalyticsFromToDate from '../../common/AnalyticsFromToDate';
import { Moment } from 'moment';
import TopScreeners from './TopScreeners';
import UnscreenedShipments from './UnscreenedShipments';
import SecurityMeasures from './SecurityMeasures';
import SecurityMethods from './ScreeningMethods';
import ScreeningAlarm from './ScreeningAlarm';
import { AnalyDetail, UnScreenedData, UnScreenedFilter, filterOptions } from '../../../models/Analytics';
import AirlineType from '../../../models/AirlineType';
import { ActiveElement, ChartEvent } from 'chart.js';

const materialStyles = (theme: Theme) =>
  createStyles({

  });

interface SecurityScreeningProps {
  classes: any;
  startDate: Moment;
  endDate: Moment;
  startTime: Moment;
  endTime: Moment;
  progress: boolean;
  carrCheck: boolean;
  carr: string;
  scr_name: string;
  report: string;
  measure: string;
  scrMeasures: string[];
  scrExemptions: string[];
  screeners: AnalyDetail[];
  filterOptions: filterOptions;
  airlines: AirlineType[];
  measures: any[string];
  alarms: number[];
  methods: any[string];
  alarmCount: number;
  shipments: UnScreenedData[];
  shipmentFilter: UnScreenedFilter;
  handleChangeCarriers: (type: string, value: boolean) => void;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeTime: (type: string, event: any) => void;
  handleChangeOption: (type: string, event: any) => void;
  handleChartClick: (event: ChartEvent, elements: ActiveElement[]) => void;
  handleChangeShipmentFilter: (type: string, event: boolean) => void;
  handleExport: (type: string) => void;
  exceedHours?: number;
  handleExceedHoursChange: (value: number) => void;
};

const SecurityScreening = (props: SecurityScreeningProps) => {

  return (
    <div className={`${commonStyles.mt4} ${commonStyles.positionRelative}`}>
      <AnalyticsFromToDate startDate={props.startDate} endDate={props.endDate} progress={props.progress} handleChangeDate={props.handleChangeDate} />

      <Grid container spacing={4} className={`${styles.customerGridContainer}`}>
        <Grid item className={`${styles.customerGridItemsFilter}`}>
          <Filters filterOptions={props.filterOptions} carrCheck={props.carrCheck} carr={props.carr} airlines={props.airlines} report={props.report} scr_name={props.scr_name} screeners={props.screeners} startTime={props.startTime} endTime={props.endTime} handleChangeTime={props.handleChangeTime} handleChangeCarriers={props.handleChangeCarriers} handleChangeOption={props.handleChangeOption} 
            handleExceedHoursChange={props.handleExceedHoursChange}
            exceedHours={props.exceedHours} 
          />
        </Grid>

        <Grid item className={`${styles.customerGridItemsData} ${styles.securityscreening}`}>
          <div className={`${styles.customerGridItems}`}>
            <Grid container spacing={3} className={`${styles.wtOuterGridContainer}`}>

              <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                <SecurityMeasures scrMeasures={props.scrMeasures} measures={props.measures} handleChartClick={props.handleChartClick} handleExport={props.handleExport} />
              </Grid>

              <Grid item xl={8} lg={8} md={6} sm={12} xs={12}>
                <SecurityMethods measure={props.measure} report={props.report} methods={props.methods} scrExemptions={props.scrExemptions} handleExport={props.handleExport} />
              </Grid>

              <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
                <Grid container spacing={3}>
                  <Grid item xl={12} lg={12} md={6} sm={12} xs={12}>
                    <ScreeningAlarm alarms={props.alarms} alarmCount={props.alarmCount} handleExport={props.handleExport} />
                  </Grid>
                  <Grid item xl={12} lg={12} md={6} sm={12} xs={12}>
                    <TopScreeners screeners={props.screeners} report={props.report} handleExport={props.handleExport} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
                <UnscreenedShipments shipmentFilter={props.shipmentFilter} handleChangeShipmentFilter={props.handleChangeShipmentFilter} shipments={props.shipments} handleExport={props.handleExport} />
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(materialStyles)(SecurityScreening);
